import { getCookie } from 'typescript-cookie';

type Environment = ImportMetaEnv['VITE_ENV'];

type Partner = 'Unknown' | 'NRMA' | 'CBA' | 'CMDirect-AU' | 'CMDirect-NZ';

type Theme = ImportMetaEnv['VITE_THEME'];

const partnerForTheme: Readonly<Record<Theme, Partner>> = {
  default: 'Unknown',
  cba: 'CBA',
  nrma: 'NRMA',
  'cmdirect-au': 'CMDirect-AU',
  'cmdirect-nz': 'CMDirect-NZ',
};

function getServiceAPIBaseURL() {
  const baseUrlDefault = import.meta.env.VITE_AUTHENTICATION_SERVICE_API_URL;
  const baseUrlStage = import.meta.env.VITE_AUTHENTICATION_SERVICE_API_URL_STAGE;
  return getCookie('BVT') === 'true' ? baseUrlStage || baseUrlDefault : baseUrlDefault;
}

function getFrontendBuild() {
  return import.meta.env.VITE_APP_FE_BUILD;
}

function getEnvironment(): Environment {
  return import.meta.env.VITE_ENV || 'dev';
}

function getPartner(): Partner {
  const partner = partnerForTheme[getTheme()];
  return partner || 'Unknown';
}

function getTheme(): Theme {
  return import.meta.env.VITE_THEME || 'default';
}

function getVersion() {
  return import.meta.env.VITE_APP_VERSION || '0.0.0';
}

function getSegmentWriteKey() {
  return import.meta.env.VITE_SEGMENT_WRITE_KEY || '';
}

export {
  getEnvironment,
  getFrontendBuild,
  getPartner,
  getSegmentWriteKey,
  getServiceAPIBaseURL,
  getTheme,
  getVersion,
};

export type { Environment, Partner, Theme };
